import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import EmployeeLaporan from "@/pages/EmployeeLaporan";
import { useAuth } from "@/context/AuthContext";

export default function EmployeeDetail() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const { isAdmin } = useAuth();

  return (
    <div className="mx-auto max-w-6xl space-y-4" data-testid="employee-detail-page">
      <button
        onClick={() => navigate(isAdmin ? "/performance/team" : "/performance")}
        className="mb-2 flex items-center gap-1 text-xs text-slate-500 hover:text-slate-300"
        data-testid="employee-detail-back"
      >
        <ArrowLeft size={14} /> Kembali ke Laporan
      </button>
      <EmployeeLaporan userId={userId} />
    </div>
  );
}
